import type { TFunction } from 'i18next';

import type { CollectionId } from '@/core/dcr/fields/types';
import type { Picklists } from '@/core/dcr/picklists';
import type { Address } from '@/core/graphql/generated/types';
import { formatAddressTitle } from '@/utils/addresses/formatAddressTitle';

type Item = Record<string, unknown>;

const asString = (value: unknown) => (typeof value === 'string' ? value : '');

export const getCollectionItemTitle = (
	collectionId: CollectionId,
	item: Item | undefined,
	picklists: Partial<Picklists>
): string => {
	if (!item) return '';

	switch (collectionId) {
		case 'address': {
			const countryName = picklists.countryOptions?.find(
				c => c.id === item.countryCda_VId
			)?.name;

			return formatAddressTitle({
				streetAddress1Cda_V: asString(item.streetAddress1Cda_V),
				streetAddress2Cda_V: asString(item.streetAddress2Cda_V),
				cityCda_V: asString(item.cityCda_V),
				countryCda_V: countryName
			} as Address);
		}
		case 'affiliation':
		case 'parentHco':
			return asString((item.parentHco as { name?: string } | null)?.name);
		case 'license':
			return asString(item.licenseNumber_V);
	}
};

export const getNewItemTitle = (collectionId: CollectionId, t: TFunction) => {
	switch (collectionId) {
		case 'address':
			return t('New Address');
		case 'affiliation':
		case 'parentHco':
			return t('New Affiliation');
		case 'license':
			return t('New License');
	}
};
